import { render, staticRenderFns } from "./plus_home.vue?vue&type=template&id=31c6e65f&scoped=true&"
import script from "./plus_home.vue?vue&type=script&lang=js&"
export * from "./plus_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6e65f",
  null
  
)

export default component.exports